import React from 'react'

const metricCards = [
  {
    id: 'single',
    title: 'Single Vouchers',
    key: 'singleTickets',
    accent: 'from-customAccent/70 via-customAccent to-customAccentBlue',
  },
  {
    id: 'parlay',
    title: 'Mix Parlay Vouchers',
    key: 'parlayTickets',
    accent: 'from-customOrange/80 via-customMustardYellow to-customLightYellow2',
  },
  {
    id: 'exposure',
    title: 'Total Risk Exposure',
    key: 'exposure',
    accent: 'from-custom_dark_primary2 via-customAccent to-customAccentBlue',
    formatter: (value) =>
      value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'MMK',
        maximumFractionDigits: 0,
      }),
  },
  {
    id: 'avg',
    title: 'Average Stake',
    key: 'avgStake',
    accent: 'from-custom_dark_primary2 via-customAccentBlue to-customVibrantGreen',
    formatter: (value) =>
      value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'MMK',
        maximumFractionDigits: 0,
      }),
  },
]

const BettingSummary = ({ totals }) => (
  <section className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
    {metricCards.map((card) => {
      const metricValue = Number(totals[card.key]) || 0
      const value = card.formatter
        ? card.formatter(metricValue)
        : metricValue.toLocaleString()

      return (
        <article
          key={card.id}
          className="min-w-0 overflow-hidden rounded-xl border border-customAccentBlue/20 bg-white shadow-md shadow-customAccentBlue/15 transition hover:shadow-lg dark:border-customSurface dark:bg-customSurface"
        >
          <div className={`h-1.5 w-full bg-gradient-to-r ${card.accent}`} aria-hidden="true" />
          <div className="flex min-h-[82px] items-center justify-between gap-3 px-4 py-3">
            <div className="min-w-0">
              <h4 className="text-sm font-semibold uppercase text-customPrimaryText dark:text-customMuted">
                {card.title}
              </h4>
              <p className="text-xs text-customSecondaryText dark:text-customMuted">Live total</p>
            </div>
            <span className="break-words text-right text-lg font-bold text-customAccentBlue dark:text-customHeading">
              {value}
            </span>
          </div>
        </article>
      )
    })}
  </section>
)

export const ParlayTotalsBySize = ({ parlayTotals = [] }) => {
  const sortedTotals = [...parlayTotals].sort(
    (first, second) => Number(first.gamblingType) - Number(second.gamblingType),
  )
  const voucherTotal = sortedTotals.reduce((sum, row) => sum + (Number(row.count) || 0), 0)

  return (
    <aside className="flex min-w-0 flex-col rounded-xl border border-customAccentBlue/20 bg-white shadow-md shadow-customAccentBlue/15 dark:border-customSurface dark:bg-customSurface">
      <header className="border-b border-customPredawn/10 bg-customSlate/60 px-4 py-3 dark:border-customSurfaceMuted dark:bg-custom_dark_primary2/40">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="text-base font-semibold text-customPrimaryText dark:text-customHeading">
              Mix Parlay by Size
            </h3>
            <p className="text-xs text-customSecondaryText dark:text-customMuted">
              Voucher count and stake by parlay size.
            </p>
          </div>
          <span className="shrink-0 rounded-full bg-customAccentBlue/10 px-3 py-1 text-xs font-semibold text-customAccentBlue dark:bg-customAccentBlue/20 dark:text-customHeading">
            {voucherTotal.toLocaleString()} total
          </span>
        </div>
      </header>

      {sortedTotals.length > 0 ? (
        <div className="grid gap-2 p-3 sm:grid-cols-2 xl:grid-cols-1 2xl:grid-cols-1">
          {sortedTotals.map((row) => (
            <div
              key={row.gamblingType}
              className="min-w-0 rounded-lg border border-customAccentBlue/15 bg-customSlate px-3 py-2 dark:border-customSurfaceMuted dark:bg-customSurfaceMuted"
            >
              <div className="flex items-center justify-between gap-2">
                <span className="text-xs font-semibold uppercase text-customSecondaryText dark:text-customMuted">
                  Mix Parlay {row.gamblingType}
                </span>
                <span className="text-base font-bold text-customAccentBlue dark:text-customHeading">
                  {(Number(row.count) || 0).toLocaleString()} Vouchers
                </span>
              </div>
              <p className="mt-1 break-words text-xs font-medium text-customPrimaryText dark:text-customHeading">
                {(Number(row.stake) || 0).toLocaleString()} MMK
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex min-h-[220px] items-center justify-center px-4 text-center text-sm text-customMuted">
          No live mix parlay vouchers found.
        </div>
      )}
    </aside>
  )
}

export default BettingSummary
